import { GET_KNOWLEDGE } from "../actions/knowledge.actions";

const initialState = [];

export default function knowledgeReducer(state = initialState, action) {
  return action.type === GET_KNOWLEDGE ? action.payload : state;
}
